module.exports = __webpack_public_path__ + "img/blue-icon(2).16bb27f7.png";